var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMusicPlayerPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.334,
    y: 9.33339,
    width: 2.66666,
    height: 13.3333,
    fill: "#212624"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.334,
    y: 9.33339,
    width: 2.66666,
    height: 13.3333,
    fill: "#212624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusicPlayerPause);
export default __webpack_public_path__ + "static/media/icon_music_player_pause.b41d9767f7c617866d33df679e8dacfd.svg";
export { ForwardRef as ReactComponent };